/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IPresetPathBlockConnections {
        blockConnectionId?: number;
        direction?: string;
        connectionTypeName?: string;
        push?: boolean;
    }

    export interface IPresetPathBlock {
        id: number;
        name: string;
        blockTypeNaturalKey?: string;
        pipePosition: string;
        serial: string;
        presetPathBlockConnections: IPresetPathBlockConnections[];
    }

    export class PresetPathBlockGroup {
        public name: string;
        public blocks: PresetPathBlock[] = [];
        public direction: string;
        public push: boolean;
        public connectionType: string;

        get detail(): string {
            return this.name + " (" + this.blocks.length + " blocks: " + this.blocks[0].name + ",....)";
        }

        get numberOfBlocks(): number {
            return this.blocks.length;
        }
    }


    export class PresetPathBlock implements IPresetPathBlock {
        public id: number;
        public name: string;
        public blockTypeNaturalKey?: string;
        public pipePosition: string;
        serial: string;
        public presetPathBlockConnections: IPresetPathBlockConnections[];

        public static Empty(): PresetPathBlock {
            return new PresetPathBlock();
        }

        constructor() {
            // empty constructor
            this.name = '';
        }

        /**
         * Checks if 2 blocks objects are equals. Two block objects are considered equal if they are referencing
         * to the same block, that is, they  have the same id. If any of the objects is undefined returns false
         * since it is not referencing to any block
         * @param block1 block to compare
         * @param block2 block to compare
         * @ return true if the objects are referencing to the same block, false otherwise
         */
        public static equals(block1: IPresetPathBlock, block2: IPresetPathBlock): boolean {
            if (block1 == undefined) {
                return false;
            }
            if (block2 == undefined) {
                return false;
            }

            return block1.id === block2.id;
        }

        /**
         * Checks if a block is a SOURCE block
         *
         * @param block block to check
         * @return true if is a SOURCE block
         */
        public static isSource(block: IPresetPathBlock): boolean {
            if (block.pipePosition !== undefined)
                return block.pipePosition === 'SOURCE';
            else
                return false;
        }

        /**
         * Checks if a block is a SINK block
         *
         * @param block block to check
         * @return true if is a SINK block
         */
        public static isSink(block: IPresetPathBlock): boolean {
            if (block.pipePosition !== undefined)
                return block.pipePosition === 'SINK';
            else
                return false;
        }

        /**
         * Checks if a block is an intermediate block
         *
         * @param block block to check
         * @return true if is an intermediate block
         */
        public static isMiddleBlock(block: IPresetPathBlock): boolean {
            if (block.pipePosition !== undefined)
                return block.pipePosition === 'NONE';
            else
                return false;
        }
    }
}
